import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { loadEnvironment } from './environments/loader';
import { disableRefreshButton } from './app/app.scripts';

const start = async () => {
  await loadEnvironment();

  if (environment.production) {
    enableProdMode();
  }

  disableRefreshButton();

  return platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
};

start();
